// Default values for diagram entities
import { Colors, View, ViewItem, Connector, TextBox, Rectangle, Icon } from 'src/types';
import { customVars } from '../styles/theme';

/**
 * Default color used for new elements
 */
export const DEFAULT_COLOR: Colors[0] = {
  id: '__DEFAULT__',
  value: customVars.customPalette.defaultColor
};

/**
 * Default font family for text elements
 */
export const DEFAULT_FONT_FAMILY = 'Roboto, Arial, sans-serif';

/**
 * Default values for new views
 */
export const VIEW_DEFAULTS: Required<
  Omit<View, 'id' | 'description' | 'lastUpdated'>
> = {
  name: 'Untitled view',
  items: [],
  connectors: [],
  rectangles: [],
  textBoxes: []
};

/**
 * Default values for view items (positioned icons)
 */
export const VIEW_ITEM_DEFAULTS: Required<Omit<ViewItem, 'id' | 'tile'>> = {
  labelHeight: 80,
  visible: true,
  locked: false,
  zIndex: 0
};

/**
 * Default values for connectors (lines between items)
 */
export const CONNECTOR_DEFAULTS: Required<Omit<Connector, 'id' | 'color'>> = {
  width: 8,
  description: '',
  anchors: [],
  style: 'SOLID',
  arrowType: 'SINGLE',
  fadeEnds: false,
  flowEnabled: false,
  flowSpeed: 0,
  flowParticleCount: 0,
  flowParticleSize: 0,
  flowDirection: 'forward',
  arrowDirection: 'forward',
  visible: true,
  locked: false,
  zIndex: 0
};

/**
 * Default values for text boxes
 */
export const TEXTBOX_DEFAULTS: Required<Omit<TextBox, 'id' | 'tile'>> = {
  orientation: 'X',
  fontSize: 0.6,
  content: 'Text',
  color: '#1f2937',
  visible: true,
  locked: false,
  zIndex: 0
};

/**
 * Padding inside text boxes
 */
export const TEXTBOX_PADDING = 0.2;

/**
 * Font weight for text boxes
 */
export const TEXTBOX_FONT_WEIGHT = 'bold';

/**
 * Default values for rectangles (area highlights)
 */
export const RECTANGLE_DEFAULTS: Required<
  Omit<Rectangle, 'id' | 'from' | 'to' | 'color' | 'borderColor' | 'description'>
> = {
  opacity: 0.3, // 30% opacity by default
  borderWidth: 2, // 2px border
  borderStyle: 'SOLID', // Solid border
  cornerRadius: 8, // 8px corner radius
  fill: true, // Fill by default
  labelPosition: 'CENTER',
  visible: true,
  locked: false,
  zIndex: 0
};

/**
 * Default icon used when no specific icon is selected
 */
export const DEFAULT_ICON: Icon = {
  id: 'default',
  name: 'block',
  isIsometric: true,
  url: ''
};

/**
 * Default height for item labels
 */
export const DEFAULT_LABEL_HEIGHT = 20;

/**
 * Empty value for markdown editor
 */
export const MARKDOWN_EMPTY_VALUE = '<p><br></p>';
